// import ScrollTrigger from '@terwanerik/scrolltrigger';
import { ajax } from 'jquery';
import easing from 'jquery.easing';
import Swiper from 'swiper';
import swiper from 'swiper/bundle';
// import 'swiper/css';
// import 'swiper/css/bundle';
// import 'swiper/css/navigation';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ModalVideo from "modal-video";

//vk sliderでimportしてるからいらないかも↓
// import Cookies from 'js-cookie';

// import lightcase from "lightcase";
// import 'lightcase/src/css/lightcase.css';


export class App {
  constructor(){
    this.html = document.documentElement;
    this.body = document.body;
    this.page = document.querySelector('.wp-site-blocks');//document.getElementById('page');
    this.header_txtContainer = document.querySelector('.page_header_inner')
    this.header = this.header_txtContainer.parentNode
    this.header.classList.add('pageHeader')
    this.iso_bar = document.createElement('div')
		this.iso_bar.setAttribute('id','isoBar')
		this.body.appendChild(this.iso_bar);
		this.blk_g = this.header.querySelector('.header_blk_t');
    this.blk_first = this.header.querySelector('ul.gnav .wp-block-navigation-item:first-child')
    // console.log(this.blk_first.offsetHeight)
    // this.blk_g = this.blk_t.querySelector(':scope > .wp-block-group');

    this.footer_share = document.querySelector('.f_btn_container');

    this.btn_contact = document.querySelector('.btn_contact a');

    this.winW = window.innerWidth;
    this.winH = window.innerHeight;

    // console.log(this.header);
    this.headerH = this.header.offsetHeight;
    this.footer_s_H = this.footer_share.offsetHeight;
    this.blkH = this.blk_first.offsetHeight//this.blk_g.scrollHeight + 10;
    // this.logoH = this.logo.offsetHeight;
    // this.logoW = this.logo.offsetWidth;

    this.menuOpen = false;
    this.ua = ua;
    this.sp = 1000;
    this.ease = "easeInOutExpo";
    this.brake = 782;

    this.swp_min_cnt = 4;

    this.btn_pageTop = document.querySelector('.btn_page_top');

    gsap.registerPlugin(ScrollTrigger)

  }

  wrapCharSpan(strs){
    return [...strs].map( tx => `<span>${tx}</span>`).join('');
  }
  
  init(){
    console.log('init');
    
    const borders = document.querySelectorAll('.is-style-inline-border');
    if(borders.length){
      borders.forEach(
        _border => {
          _border.innerHTML = `<span class="txt">${_border.innerHTML}</span>`;
        }
      )
    }

    const circlenums = document.querySelectorAll('.is-style-circle-num');
    if(circlenums.length){
      circlenums.forEach(
        _circle => {
          const _pa = _circle.parentNode
          _pa.classList.add('circle_parent')
          _circle.innerHTML = `<span class="num">${_circle.innerHTML}</span>`;
        }
      )
    }

    const item_br = document.querySelectorAll('.gnav .wp-block-navigation-item .wp-block-navigation-link .wp-block-navigation-item__label')
    item_br.forEach(
      _br  => {
        _br.innerHTML = _br.innerHTML.replace(/-/g, "<br>")
      }
    )

    const customDlLists = document.querySelectorAll('.customDlList');
    customDlLists.forEach(
      _dl => {
        const _dts = _dl.querySelectorAll('dt');
        _dts.forEach(
          _dt => {
            _dt.innerHTML = `<span class="txt">${_dt.innerHTML}</span>`
          }
        )
      }
    )

    const acLists = document.querySelectorAll('.is-style-ac-list');
    acLists.forEach(
      _ac => {
        const _children = _ac.querySelectorAll(':scope > .wp-block-group')
        _children.forEach(
          _ch => {
            _ch.classList.add('ac_child')
            // _ch.querySelector('.wp-block-group').classList.add('ac_header')
          }
        )

        const _btns = _ac.querySelectorAll('.btn_open');
        _btns.forEach(
          _btn => {
            const _a = _btn.querySelector('.wp-block-button__link');
            _a.innerHTML = `<span class="txt">${_a.innerHTML}</span>`

            _btn.addEventListener('click', (e) => {
              const _pa = _btn.closest('.ac_child')
              const _inn = _pa.querySelector('.innerList1')

              if(_btn.classList.contains('on')){
                _btn.classList.remove('on')
                _inn.style.maxHeight = '0'
                _btn.querySelector('.txt').textContent = '詳細を見る'
              }else{
                _btn.classList.add('on')
                _inn.style.maxHeight = _inn.scrollHeight+"px"
                _btn.querySelector('.txt').textContent = '詳細を閉じる'
              }
            })
          }
        )
      }
    )

    const _btn_blks = document.querySelectorAll('.btn_blk');
    if(_btn_blks.length){
      _btn_blks.forEach(
        _btn => {
          if(_btn.querySelector('a').innerHTML){
            const _a  = _btn.querySelector('a');
          _a.innerHTML = `<span class="txtContainer"><span class="txt">${_a.innerHTML}</span><i class="fa-solid fa-arrow-up-right-from-square"></i></span>`
          }else{
            _btn.innerHTML = `<span class="txtContainer">${_btn.innerHTML}<i class="fa-solid fa-arrow-up-right-from-square"></i></span>`
          }
        }
      )
    }

    // console.log(document.querySelector('.innerList1').scrollHeight)

    if(this.is_frontpage){

      // if(this.ua === "mobile" && !map_disable){
      // }
    }else{
      
    }






    window.addEventListener('load', (e) => {
      $('.spinner').fadeOut('slow',function(){
        $(this).remove();
      });
      this.body.classList.add('loaded');
      this.page.classList.add('on');

      this.makeSwiper();

      if(this.body.classList.contains('home')){ 

      }

      if(this.body.classList.contains('single')){ 
				// console.log('is single'+cur_url)
				const x_link = document.querySelector('.post_social_link .wp-social-link-x .wp-block-social-link-anchor');
				const f_link = document.querySelector('.post_social_link .wp-social-link-facebook .wp-block-social-link-anchor');
				if(x_link){
					x_link.href = "http://x.com/share?url="+cur_url+"&text="+page_ttl
					x_link.target = '_blank'
					x_link.rel = 'nofollow noopener noreferrer'
				}
				if(f_link){
					console.log('is single'+f_link)
					f_link.href="http://www.facebook.com/share.php?u="+cur_url
					f_link.target = '_blank'
					f_link.rel = 'nofollow noopener noreferrer'
				}
      }

      
      if(this.body.classList.contains('parent_teacher_training') || 
      this.body.classList.contains('page-teacher_training')){
        const _txt = this.btn_contact.innerText.replace('@', '教員研修');
        this.btn_contact.innerText = _txt
        this.btn_contact.href = "/teacher_training/contact_teacher_training"
      }
      else if(this.body.classList.contains('parent_support_training') || 
      this.body.classList.contains('page-support_training')){
        const _txt = this.btn_contact.innerText.replace('@', '教育事業');
        this.btn_contact.innerText = _txt
        this.btn_contact.href = "/support_training/contact_support_training"
      }
      else if(this.body.classList.contains('parent_educational_material') || 
      this.body.classList.contains('page-educational_material')){
        const _txt = this.btn_contact.innerText.replace('@', '録音事業');
        this.btn_contact.innerText = _txt
        this.btn_contact.href = "/educational_material/contact_educational_material"
      }
      else if(this.body.classList.contains('parent_english_education_institute') || 
      this.body.classList.contains('page-english_education_institute')
      // this.body.classList.contains('tax-research-report-cat') || 
      // this.body.classList.contains('tax-elecbulletin-cat') || 
      // this.body.classList.contains('term-english_education_institute_cat')
      ){
        const _txt = this.btn_contact.innerText.replace('@', '研究所');
        this.btn_contact.innerText = _txt
        this.btn_contact.href = "/english_education_institute/contact_english_education_institute"
      }
      else{
        const _txt = this.btn_contact.innerText.replace('@', 'ELEC');
        this.btn_contact.innerText = _txt
        this.btn_contact.href = "/contact"
      }
      
      
      if(this.body.classList.contains('single-case-study')){ 
        // const wrap = document.querySelector('.content_wrap')
        // const slug = document.createElement('p')
        // slug.innerText = "Case Study"
        // slug.classList.add('post_type_slug')
        // wrap.appendChild(slug)
      }
      
      if(
        this.body.classList.contains('page-contact_teacher_training')
        ){ 
          // const f_reqs = document.querySelectorAll('.f_req');
          // f_reqs.forEach(
          //   _req => {
          //   }
          // )
      }

      if(typeof page_type !== 'undefined'){
        if(page_type == "contact"){
          // const _form = document.querySelector('form.snow-monkey-form');
          // console.log(_form)
          // const c_name = document.createElement('span');
          // c_name.classList.add('p-country-name')
          // c_name.style.display = 'none'
          // c_name.innerText = 'Japan'
          // _form.classList.add('h-adr');
          // _form.appendChild(c_name)
        }
      }

     

      const _year = document.getElementById('year')
      const _dateY = new Date().getFullYear();
      _year.innerHTML = _dateY

			this.makeSp();

      this.makeAnchor();

      this.resize();

      this.events();

      this.makeYt();

      // this.trigger();


    });
    
  }




  // buildMap(_id, marker_data, options_data, state){
  //   this.gmap = new GmapCtrl(_id, marker_data, options_data, state, this.ua);
  // }

  makeYt(){
    const yts = document.querySelectorAll('.btn_yt')
    if(yts){
      yts.forEach(
        _yt => {
          _yt.setAttribute('data-video-id', _yt.id)
        }
      )
      new ModalVideo('.btn_yt',{channel: 'youtube'});
      // console.log(ModalVideo);
    }
  }

  queryMatch(jud){
    // console.log(jud);
    if(jud === 'sp'){

    }else{
      
      // console.log(this.menuOpen);
    }
  }

  faqNext(){
    const faqList = document.querySelector('.faqList');

    const _dts = faqList.querySelectorAll('dt');
    _dts.forEach(
      _dt => {
        _dt.addEventListener('click', (e) => {
          const _tar = e.currentTarget;
          const _dd = _tar.nextElementSibling;

          if(_tar.classList.contains('on')){
            _tar.classList.remove('on');
            _dd.style.maxHeight=0;
          }else{
            _tar.classList.add('on');
            const _h = _dd.querySelector('.inner').offsetHeight;
            _dd.style.maxHeight=_h+"px";
          }
          // const _dd = _tar.siblings('dd');
          

        });
      }
    )
  }

  makeAnchor(){

    let _items_g
    let _items_f

    // console.log(this.ua)

    if(this.body.classList.contains('page-narratorarrangement_translationproofreading_cdpress')){
      // this.body.addEventListener('click', e => {console.log('body click')})
      if(this.ua === 'others'){
        _items_g = document.querySelectorAll('.gnav .item-educational_material .gnav_sub_ul .wp-block-navigation-item a')
      }else{
        _items_g = document.querySelectorAll('.gnav_nav .item-sp-educational_material .gnav_sub_ul .wp-block-navigation-item a')
      }
      _items_f = document.querySelectorAll('.fnav .list-educational_material a')
    }else if(this.body.classList.contains('page-about_elec')){
      _items_f = document.querySelectorAll('.fnav .list-about_elec a')
    }

    // console.log(_items_g)
    
      if(_items_g){
        this.makeAnchorLink(_items_g,'gnav')
      }
      if(_items_f){
        this.makeAnchorLink(_items_f,'fnav')
      }
    
  }

  makeAnchorLink(_items, _st='gnav'){
    _items.forEach(
      _item => {
        if(_item.href.indexOf('#')){
          const _pos = _item.href.indexOf('#')
          if(_pos > 0){
            _item.href = _item.href.slice(_pos)

            if(_st === 'gnav'){
              console.log('gnav')
              _item.addEventListener('click', (e) => {
                const _pa =  _item.closest('li.has-child')
                const _sub = _pa.querySelector('.wp-block-navigation__submenu-container');
                
                _sub.style.height = 0
                _sub.style.opacity = 0
                _sub.style.overflow = 'hidden'
                _sub.style.visibility = 'hidden'

              setTimeout((e) => {
                _sub.setAttribute('style','')
                console.log(_pa)
              },100)
                // _pa.style.pointerEvents='none'
                //this.body.dispatchEvent(new Event('click'))
              })
            }

          }
        }
      }
    )
  }


  events(){

    this.btn_pageTop.addEventListener('click', (e) => {
      this.anim(this.body);
    })

    window.addEventListener('scroll', (e) => { this.scroll(); });
    window.addEventListener('resize',(e)=>{this.resize();});

    


  

   
    const atags = document.querySelectorAll("a[href^='#']");
    // console.log(atags);
    this.pageLink(atags);

    this.bet = 0;
    const options = {
      root:null,
      rootMargin:`${this.bet}px`,
      threshold: 0.1
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(
        entry => {
          // console.log(entry.isIntersecting);
          if(entry.target.id === 'isoBar'){
            if(entry.intersectionRatio > 0.1){
              this.header.classList.remove('hd')
            }else{
              this.header.classList.add('hd')
            }
          }
          // if(entry.isIntersecting){
          //   this.btnWrap.classList.remove('on');
          // }else{
          //   this.btnWrap.classList.add('on');
          // }
        //  if(entry.target.classList.contains('headerContainer')){
        //   // console.log(entry.intersectionRatio);
        //   if(entry.intersectionRatio < 0.1 ){
        //     // console.log(entry.intersectionRatio);
        //     // this.btn_pagetop.classList.add('on');
        //   }else{
        //     // console.log(entry.intersectionRatio);
        //     // this.btn_pagetop.classList.remove('on');
        //   }
        //  }

        }
      )
    }, options);

    if(this.ua !== "mobile"){
      // this.ov_ttl = document.querySelector('.site-title');
      // observer.observe(this.ov_ttl);
      observer.observe(this.iso_bar);
    }

				// this.btn_sp.addEventListener('click',(e) => {
    //     // console.log('sp');
    //     if(this.header.classList.contains('on')){
    //       this.menuOff();
    //     }else{
    //       this.menuOn();
    //     }
    //   });
      // this.menu_back.addEventListener('click', (e) => {
      //   this.menuOff();
      // });
    
    if(!this.body.classList.contains('home')){
      

      
    }else{// home
      // if(this.ua === "mobile"){
      //   const _secContainer = document.querySelector('.headerContainer');
      //   // observer.observe(_secContainer);
      // }
      // // console.log(observer);
      // const bnr_donation = document.getElementById('bnr_donation');
      // if(bnr_donation){
      // const sec_proc = document.querySelector('.sec-process');
      // // console.log(bnr_donation);
      // sec_proc.appendChild(bnr_donation);
      // bnr_donation.outerHTML = `<div class='bnrContainer mx-sp-500'>${bnr_donation.outerHTML}</div>`;
      // }

    }

    if(this.body.classList.contains('faq')){
     
    }

    

    // if(this.body.classList.contains('contact')){
    //   const _form = document.querySelector('div[id ^= "mw_wp_form_mw-wp-form-"]');
    //   if(_form.classList.contains('mw_wp_form_input')){
    //     const _check = document.querySelector('input[type=checkbox]');
    //     const _btnContainer = document.getElementById('btnContainer');
    //     if(_check.checked){ _btnContainer.classList.add('on');}
        
    //     _check.addEventListener('click',(e)=>{
    //       if(e.currentTarget.checked){
    //         _btnContainer.classList.add('on');
    //       }else{
    //         _btnContainer.classList.remove('on');
    //       }
    //     });
    //   }
    // }

    // if(this.body.classList.contains('single') || 
    // this.body.classList.contains('page')){
    //   $('a[data-rel^=lightcase]').lightcase({
    //     maxHeight:2000,
    //     maxWidth:2000
    //   });
    // }
    if(this.body.classList.contains('single')) {
      const content_wrap = document.querySelector('.content_wrap');
      const side = document.createElement('div');
      side.classList.add('side');
      content_wrap.appendChild(side);
    }

    if(this.body.classList.contains('page-parent')){
      const paras = document.querySelectorAll('.is-style-cover_pa_para');
      
      paras.forEach(
        _para => {
          gsap.fromTo(_para.querySelector('img'), {
            y: "-15%"
          }, {
            y:"0",
            ease: "none",
            scrollTrigger: {
              trigger: _para,
              start: `top top+=${this.headerH}`,
              end: `bottom top+=${this.headerH}`,
              scrub: 1.2
            }
          })
        }
      )
    }
    if(this.body.classList.contains('page-child')){
      const paras = document.querySelectorAll('.is-style-cover_ch_para');
      
      paras.forEach(
        _para => {
          gsap.fromTo(_para.querySelector('img'), {
            y: "-15%"
          }, {
            y:"0",
            ease: "none",
            scrollTrigger: {
              trigger: _para,
              start: `top top+=${this.headerH}`,
              end: `bottom top+=${this.headerH}`,
              scrub: 1.2
            }
          })
        }
      )
      const page_ttl = document.querySelector('.page__ttlContainer h1');
      const pa_elm_container = document.createElement('div')
      pa_elm_container.classList.add('parentContainer');
      console.log(pa_ttl)

      if(typeof cat_image !== 'undefined'){
        const img_container = document.createElement('div');
        img_container.classList.add('img_container')

        const pa_img = document.createElement('img')
        pa_img.src = cat_image
        img_container.appendChild(pa_img)
        pa_elm_container.appendChild(img_container)
      }

      const pa_elm = document.createElement('p');
      pa_elm.classList.add('parent_page')
      pa_elm.innerHTML = pa_ttl
      pa_elm_container.appendChild(pa_elm)
      page_ttl.insertAdjacentElement('beforebegin', pa_elm_container)

      // console.log(pa_elm)
    }


    if(this.body.classList.contains('page-news') || 
    this.body.classList.contains('page-news__cat')){
      const catSelectWrap = document.getElementById('catSelect');
      catSelectWrap.outerHTML = `<div class="selectWrap">${catSelectWrap.outerHTML}</div>`;
      const catSelect = document.getElementById('catSelect');
      // console.log(catSelect.length)
      if(catSelect.length){
        catSelect.addEventListener('change', (e) => {
          location.href=e.target.value
        });
      }
    }


    const mediaQueryList = window.matchMedia('(min-width:782px)');
    const listener = (e) => {
      if(e.matches){
        this.queryMatch('pc');
        
      }else{
        this.queryMatch('sp');
      }
    }
    mediaQueryList.addEventListener('change', listener);

    listener(mediaQueryList);
    

  }
  
  pageLink(atg){
    const _atags = atg;
    for (const _a of _atags) {
          // console.log(_a);
      _a.addEventListener('click', (e) => {
        e.preventDefault();
        let href = e.currentTarget.getAttribute('href');
        if (href == "#" || href == "") {
          href = "#page";
          this.sp = 1200;
        }
        href = href.replace("#", "");
        const target = document.getElementById(href);
        setTimeout((e) => {
          this.anim(target);
        }, 100);
      });
    }
  }
  

  makeSp(){

    this.gnavContainerSp = document.createElement('div');
    this.gnav = this.header.querySelector('.gnav_container');
    this.gnavParent = this.gnav.parentNode;
    const site_ttl_sp = document.createElement('p');
    site_ttl_sp.innerHTML = `<span class="txt"><span class="u_smm">一般財団法人</span> 英語教育協議会</span>`;
    site_ttl_sp.classList.add('site_title_sp')
    this.gnavParent.appendChild(site_ttl_sp);

    const site_ttl_pc = this.gnav.querySelector('.site-ttl');
    site_ttl_pc.innerHTML = `<span class="u_smm">一般財団法人</span> 英語教育協議会<span class="tx">（<ruby>ELEC<rt>エレック</rt></ruby></span>）`
    
    this.gnav_sub_ul = this.gnav.querySelectorAll('.wp-block-navigation__submenu-container');
    this.gnav_sub_ul.forEach(
      _sub_ul => {
        const _cl = _sub_ul.className
        _sub_ul.setAttribute('class','gnav_sub_ul')
        _sub_ul.outerHTML = `<div class="${_cl}">${_sub_ul.outerHTML}</div>`
      }
    )

    //sp
    this.gnavSp = this.gnav.cloneNode(true);
    const site_ttl = this.gnavSp.querySelector('.site-ttl')
    site_ttl.parentNode.removeChild(site_ttl)
    this.nav_gnav = this.gnavSp.querySelector('nav.gnav')
    this.nav_gnav.setAttribute('class','gnav_nav')
    // this.nav_gnav.setAttribute('style', '')
    // .setAttribute('style','')
    this.ul_gnav = this.gnavSp.querySelector('ul.gnav')
    this.ul_gnav_item = this.ul_gnav.querySelectorAll(':scope > .wp-block-navigation-item')
    this.ul_gnav.setAttribute('class','gnav_ul')
    this.ul_gnav_item.forEach(
      _li => {
        let _cl = "gnav_ul-item"
        // if(_li.classList.contains)
        _li.classList.forEach(
          _cll => {
            // console.log(_cll.indexOf('item-'))
            if(_cll.indexOf('item-') >= 0){
             _cl += (" " + _cll.replace('item-','item-sp-'))
            }
          }
        )
        // console.log(_cl)
        _li.setAttribute('class', _cl)

        const _a = _li.querySelector('a');
       
        _a.outerHTML = `<div class="gnav_ul-item__wrap">${_a.outerHTML}<button class="btn_sub"></button></div>`;
        // _li.appendChild(_btn)
      }
    )


    this.ul_gnav_sub_ul = this.ul_gnav.querySelectorAll('.wp-block-navigation__submenu-container');
    this.ul_gnav_sub_ul.forEach(
      _sub_ul => {
        _sub_ul.setAttribute('class', 'gnav_ul-item__sub_ul')
      }
    )


    this.ul_gnav_item.forEach(
      _li => {
        const _btn = _li.querySelector('.btn_sub')
        const _sub = _li.querySelector('.gnav_ul-item__sub_ul');
        
        _btn.addEventListener('click', (e) => {
          // console.log(_sub)
          if(_btn.classList.contains('on')){
            _btn.classList.remove('on')
            $(_sub).slideUp('slow')
          }else{
            _btn.classList.add('on')
            $(_sub).slideDown('slow')
          }
        });
      }
    );


    this.gnavSp.setAttribute('class', 'gnavContainerSp__inner');
    this.gnavSp.setAttribute('style', '')
    this.gnavSp.querySelector('div').setAttribute('class', 'gnavContainerSp__inner-box')
    this.gnavSp.querySelector('div').setAttribute('style', '')
    const _is_flex = this.gnavSp.querySelector('.is-layout-flex')
    _is_flex.setAttribute('class', 'menuWrapSp pageHeader__btnContainer')
    _is_flex.setAttribute('style', '')
    
    _is_flex.querySelectorAll(':scope > p').forEach(
      _p => {
        _p.setAttribute('class', 'has-primary-background-color has-base-color pageHeader__btnContainer-btn')
        _p.setAttribute('style', '')
      }
    )
    

    // console.log(this.gnavSp.querySelector('div'))
    this.gnavContainerSp.classList.add('gnavContainerSp')
    this.gnavContainerSp.appendChild(this.gnavSp);
    this.header.appendChild(this.gnavContainerSp);
    this.btn_sp = document.createElement('div');
    this.btn_sp.classList.add('btnSp');
    // this.btn_sp.classList.add('sp');
    this.btn_sp.innerHTML = `<div class='btnSp-inner'>
    <span class="bar"></span><span class="bar"></span><span class="bar"></span>
    </div><span class="txt">MENU</span>`;
    // this.header_inner.insertBefore(this.btn_sp, this.header.firstElementChild);
			this.header.appendChild(this.btn_sp);

    


    
    this.menu_back = document.createElement('div');
    this.menu_back.classList.add('gnav-back');
    this.gnavContainerSp.appendChild(this.menu_back);

    this.btn_close = document.createElement('div');
    this.btn_close.classList.add('btn_close');
    this.btn_close.innerHTML = `<span class="bar"></span><span class="bar"></span>`;
    this.gnavContainerSp.appendChild(this.btn_close);

    this.btn_close.addEventListener('click', (e) => {
      this.menuOff();
    });
    this.menu_back.addEventListener('click', (e) => {
      this.menuOff();
    });

    // this.gnav.querySelectorAll('.item-nav_cl a').forEach(
    //   _nav_cl => {
    //     _nav_cl.addEventListener('click', (e) => {
    //       // e.preventDefault();
    //       this.menuOff();
    //     });
    //   }
    // )

    this.btn_sp.addEventListener('click', (e) => {
      
      if(this.header.classList.contains('on')){
        this.menuOff();
      }else{
        this.menuOn();
      }
    });

    const _linkSp = this.gnavContainerSp.querySelectorAll('.wp-block-navigation-item__content')
    _linkSp.forEach(
      _link => {
        _link.addEventListener('click', (e) => {
          this.menuOff()
        })
      }
    )
  }
  menuOff(){
			// console.log('off');
    this.menuOpen = false;
    this.header.classList.remove('on');
    this.btn_sp.querySelector('.bar:nth-child(1)').style.animationName = "bar1";
    this.btn_sp.querySelector('.bar:nth-child(3)').style.animationName = "bar3";
  }
  menuOn(){
    this.menuOpen = true;
    this.header.classList.add('on');
				// console.log(this.header.classList);
  }



  
  makeSwiper(){
    //  console.log('makeswiper')
     

    // if(!this.body.classList.contains('single')){
    //   this.swipers = document.querySelectorAll('.swp');
    // }else{
    //   console.log('single swiper');
    //   this.swipers = document.querySelectorAll('.swp');
    // }
    this.swipers = document.querySelectorAll('.swp');
    // console.log(this.swipers.length);
    
    if(this.swipers.length > 0){
      
      let swObj = {
        speed: 1000,
        loop: true,
        allowTouchMove: true,
        slidesPerView:1,
        autoplay:{
          delay:5000,disableOnInteraction:false
        }
      }
      let sw_cnt = 1;
      let sw_cnt2 = 1;
      this.sw_arr = [];

      this.swipers.forEach(
        swp => {
          //console.log(swp);
          swp.classList.add('sw'+sw_cnt);
          const _slides = swp.querySelectorAll('.wp-block-post')
          if(this.swp_min_cnt > _slides.length){
            swp.classList.remove('swiper')
            swp.classList.remove('swp')
            swp.classList.add('before_swp')
            return;
          }

          _slides.forEach(
            _sl => {
              _sl.classList.add('swiper-slide')
            }
          )









          let _delay = 2000;
          if(swp.dataset.delay){
            _delay = swp.dataset.delay * 1000;
          }
          let _speed = 1000;
          if(swp.dataset.speed){
            _speed = swp.dataset.speed * 1000;
          }
          //console.log(_speed);
          const sl_len = document.querySelectorAll('.swiper .swiper-slide').length;
          if(sl_len == 1){
            swObj.loop = false;
            swObj.autoplay = false;
          }

          if(swp.classList.contains('fade')){
            //console.log('fade');
           if(sl_len > 1){
           //console.log("len="+sl_len, "del="+_delay, "sp="+_speed);

            
            swObj.slidesPerView = 1;
            // swObj.parallax = true;
            swObj.speed = _speed;
            swObj.autoplay = {delay:_delay,disableOnInteraction:false};
            swObj.effect= 'fade';
           }
          }else if(swp.classList.contains('slide')){
            //console.log('slide');
            if(sl_len > 1){
              swObj.slidesPerView = 1;
            // swObj.parallax = true;
            swObj.speed = _speed;
            swObj.autoplay = false;
            // swObj.autoplay = {delay:_delay,disableOnInteraction:false};
            swObj.effect= 'slide';

            swObj.navigation = {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            };
            swObj.slidesPerGroup = 1; 
            // console.log(this.ua)
              if(this.ua == "mobile"){ swObj.slidesPerGroup = 1;  }
              swObj.breakpoints = {
                782:{
                  slidesPerView : 3,
                  spaceBetween : 40,
                  slidesPerGroup : 3
                }
              };
              
            }



            

            if(swp.classList.contains('sw_st_top')){
              swObj.slidesPerView = 1.5;
              swObj.speed = 1000;
              swObj.autoplay = false;
              swObj.spaceBetween = 20;
              swObj.centeredSlides = true;
              swObj.navigation = {
                nextEl: '.st_btn_next',
                prevEl: '.st_btn_prev'
              };
              swObj.slidesPerGroup = 3; 
              console.log(this.ua)
              if(this.ua == "mobile"){ swObj.slidesPerGroup = 1;  }
              swObj.breakpoints = {
                897:{
                  slidesPerView : 3,
                  spaceBetween : 54
                },
                1000:{
                  slidesPerView : 3,
                 spaceBetween : 90
                }
              };
            }else if(swp.classList.contains('sw_stb_top')){
              swObj.autoplay = false;
              swObj.slidesPerView = 1.2;
              swObj.spaceBetween = 34;
              swObj.centeredSlides = true;
              swObj.navigation = {
                nextEl: '.stb_btn_next',
                prevEl: '.stb_btn_prev'
              };
              swObj.breakpoints = {
                640:{
                  spaceBetween : 54,
                  slidesPerView : 1.7
                },
                897:{
                  spaceBetween : 54,
                  slidesPerView : 2.1
                },
                1000:{
                  spaceBetween : 100,
                  slidesPerView : 2.1
                },
                1200:{
                  spaceBetween : 200,
                  slidesPerView : 2.5
                }
              };
            }
          }else{
            console.log('sw.length > 2 no hero');
            swObj.loop = true;
            swObj.slidesPerView = 1;
            swObj.autoplay = false;
            swObj.breakpoints = {
              //897:{
              //   slidesPerView:4
              // },
              // 1001:{
              //   slidesPerView:4
              // },
            };
            swObj.navigation = {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            };
            swObj.pagination= {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            };

            if(swp.classList.contains('top_sw')){
              swObj.effect='fade';
              swObj.autoplay = {delay:3000,disableOnInteraction:false};
            }
            if(swp.classList.contains('list_sw')){
              console.log('list sw');
               swObj.centeredSlides = true;
              swObj.slidesPerView = 'auto';
              // swObj.spaceBetween = 80;
              swObj.speed = 1000;
              swObj.autoplay = {delay:3000,disableOnInteraction:false};
              swObj.effect='slide';
            }
            if(swp.classList.contains('spot_sw')){
              swObj.speed = 1000;
              // swObj.autoplay = {delay:5000,disableOnInteraction:false};
              swObj.effect='slide';
              // swObj.allowTouchMove = false;
              // swObj.navigation = {
              //   nextEl: '.swiper-button-next-spot',
              //   prevEl: '.swiper-button-prev-spot'
              // };

              delete swObj.pagination;
            
            }
            // const swiper = new Swiper('.swiper',swObj);
          }

          if(swp.classList.contains('sw_shop')){
            swObj.pagination= {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            };
          }

          if(swp.classList.contains('notice')){
            swObj.pagination = "";
            delete swObj.pagination;
          }
          
          if(swp.classList.contains('gp_sw')){
            // console.log(sw_delay)
            // swObj.autoplay = {delay:3000,disableOnInteraction:false};
            swObj.pagination= {
              el: '.swiper-pagination',
              type: 'bullets',
              clickable: true
            };
          }

          // console.log('.sw'+sw_cnt2);
          // console.log(sw_cnt2, swObj);
          const _swiper = new Swiper('.sw'+sw_cnt2,swObj);
          let _name = '';
          if(swp.classList.contains('spot_sw')){
            _name = 'spot_sw';
          }else{
            _name = 'sw'+sw_cnt2;
          }
          this.sw_arr[_name] = _swiper;
          // console.log(this.sw_arr);
          sw_cnt2++;















          sw_cnt++;
        }
        
      );
      
    }

    // const _ab_image = document.querySelectorAll('.about_sl.image');
    // // console.log(swObj_ab);
      
    // const _sw_ab_image = new Swiper('.about_sl.image',{
    //   speed: 1000,
    //   effect: 'fade',
    //   watchSlidesProgress:true,
    //   allowTouchMove: false
    // });

    // let swObj_ab = {
    //   speed: 1000,
    //   loop: true,
    //   effect: 'slide',
    //   allowTouchMove: true,
    //   slidesPerView:1,
    //   autoplay:{
    //     delay:5000
    //   },
    //   navigation:{
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev'
    //   },
    //   pagination:{
    //     el: '.swiper-pagination',
    //     type: 'bullets',
    //     clickable: true
    //   },
    //   thumbs: {
    //     swiper: _sw_ab_image,
    //   },
    // }

    // const _sw_ab_text = new Swiper('.about_sl.text',swObj_ab);

    
  }
  scroll(){
    if(!this.is_frontpage){
      // console.log(window.pageYOffset);
    }
  }
  resize(){
    this.get_size();


      this.html.style.setProperty('--hh', this.headerH+"px");
      // this.html.style.setProperty('--lgh', this.logoH+"px");
      // this.html.style.setProperty('--lgw', this.logoW+"px");
      this.html.style.setProperty('--fh', this.footer_s_H+"px");
      this.html.style.setProperty('--bkh', this.blkH);

      if(this.map){
        this.html.style.setProperty('--ctr',this.mapControll.offsetHeight+"px");
      }


   
  }
  get_size(){
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    // this.logoH = this.logo.offsetHeight;
    // this.logoW = this.logo.offsetWidth;
    this.headerH = this.header.offsetHeight;
    // console.log(this.blk_first.offsetHeight)
    this.blkH = ((this.blk_first.offsetHeight + 10) > 33) ? this.blk_first.offsetHeight + 10 : 33;
    // this.blkH = ((this.blk_g.scrollHeight + 10) > 33) ? this.blk_g.scrollHeight + 10 : 33;
  }
  anim(_t,_tt=this.sp) {
    const rect = _t.getBoundingClientRect();
    const scT = window.pageYOffset || document.documentElement.scrollTop;
    let targetT  = rect.top;

    targetT = rect.top + scT - this.headerH;

    if(this.body.classList.contains('foo-xx')){
       // - this.headerH;
       targetT = rect.top + scT - this.headerH - this.catListContainer.offsetHeight;
      //  console.log(document.getElementById('catListContainer').offsetHeight);
    }
    // console.log(_tt);
    $('html,body').animate({
      scrollTop: targetT
    }, _tt, this.ease);
  }


  trigger(){
    this.trigger = new ScrollTrigger({
      trigger: {
        offset: {
          viewport: {
            x: 0,
            y: (trigger, rect, direction) => {
              return 0.1;
            }
          }
        },
        toggle: {
          callback: {
            in:(trigger)=>{
            },
            out:(trigger)=>{
            }
          }
        }
      }
    });
    this.trigger.add('[data-scroll]', {
      once: true,
      toggle: {
        class: {
          in: 'animIn',
          out: 'animOut'
        },
        callback: {
          in:(trigger) => {
            // if(trigger.element.classList.contains('img_circle')){
            //   setTimeout((e) => {
            //     console.log('beginElement');
            //     this.animate.beginElement();
            //     document.getElementById('img_circle').classList.add('on');
            //   },200);
            // }
          },
          out:(trigger) => {

          }
        }
      }
    })
  }
  
}
